<!-- Year navigation -->
<div class="flex items-center justify-between mb-base">
  <button class="p-xs rounded-sm hover:bg-ui-hover cursor-pointer" (click)="navigateYear(-1)">
    <svg-icon key="chevron-left" class="!text-base"></svg-icon>
  </button>
  <div class="text-base leading-base font-semibold">{{ viewYear() }}</div>
  <button
    class="p-xs rounded-sm hover:bg-ui-hover cursor-pointer"
    [class.opacity-30]="!includeFuture() && viewYear() >= currentYear"
    [disabled]="!includeFuture() && viewYear() >= currentYear"
    (click)="navigateYear(1)"
  >
    <svg-icon key="chevron-right" class="!text-base"></svg-icon>
  </button>
</div>

<!-- Month grid (3x4) -->
<div class="grid grid-cols-3 gap-sm">
  @for (month of months; track month; let i = $index) {
    <div
      class="p-sm rounded-sm border border-ui-separator flex items-center justify-center text-sm leading-xs cursor-pointer select-none hover:bg-ui-hover"
      [class.!bg-primary]="selectedYear() === viewYear() && selectedMonthIndex() === i"
      [class.!border-primary]="selectedYear() === viewYear() && selectedMonthIndex() === i"
      [class.!text-white]="selectedYear() === viewYear() && selectedMonthIndex() === i"
      [class.opacity-30]="disabledMonths()[i]"
      [class.!cursor-not-allowed]="disabledMonths()[i]"
      (click)="selectMonth(i)"
    >
      {{ month | slice: 0 : 3 }}
    </div>
  }
</div>
